import _axios from "axios";
import backendConstants from "src/app/constants/backend.constants";
import localStorageConstants from "src/app/constants/localStorage.constants";

const axios = _axios.create({
  validateStatus: () => true,
  baseURL: backendConstants.BASE_URL,
  timeout: 30000,
});

export const setToken = async () => {
  const userToken = localStorage.getItem(localStorageConstants.TOKEN);
  if (!userToken) return;
  axios.defaults.headers.common["Authorization"] = `Bearer ${userToken}`;
};

axios.defaults.headers.common["Accept"] = "application/json, text/plain, */*";
axios.defaults.headers.common["Content-Type"] = "application/json";

export default axios;
